export const ImportAll = (r: any) => r.keys().map(r);

export const shuffleArray = <T>(array: T[]): T[] => {
  const arr = [...array]; // Create a copy so the original array is not mutated
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]]; // Swap elements
  }
  return arr;
};
